import React from "react";
import "../styles/Layout.css";
import "../styles/Components.css";
import "../styles/Screens.css";

const ImpressumScreen = ({ onBack }) => {
  return (
    <div className="legal-screen">
      <button className="back-button" onClick={onBack}>
        ← Zurück
      </button>

      <div className="legal-content">
        <h1 className="legal-title">Impressum</h1>

        <section className="legal-section">
          <h2>Adrian Hufnagl</h2>

          <div className="legal-block">
            <h3>INHABER</h3>
            <p>Dipl.Ing. Adrian Hufnagl, BA</p>
          </div>

          <div className="legal-block">
            <h3>ADRESSE</h3>
            <p>Bindergasse 11/30, 1090 Wien, AUSTRIA</p>
          </div>

          <div className="legal-block">
            <h3>KONTAKT</h3>
            <p>+43 (0) 660 2442 011</p>
            <p>hello@cyberhoof.at</p>
          </div>
        </section>

        <section className="legal-section">
          <h2>Unternehmensdaten</h2>

          <div className="legal-grid">
            <div className="legal-block">
              <h3>UID</h3>
              <p>ATU82732401</p>
            </div>

            <div className="legal-block">
              <h3>RECHTSFORM</h3>
              <p>Einzelunternehmen</p>
            </div>

            <div className="legal-block">
              <h3>GERICHTSSTAND</h3>
              <p>Wien, Österreich</p>
            </div>

            <div className="legal-block">
              <h3>GEWERBE</h3>
              <p>
                Dienstleistungen in der automatischen Datenverarbeitung und
                Informationstechnik
              </p>
            </div>

            <div className="legal-block">
              <h3>KAMMER-ZUGEHÖRIGKEIT</h3>
              <p>Wirtschaftskammer Wien</p>
            </div>

            <div className="legal-block">
              <h3>ZUSTÄNDIGES GERICHT</h3>
              <p>Handelsgericht Wien</p>
            </div>
          </div>
        </section>

        <section className="legal-section">
          <h2>Haftungsausschluss &amp; Urheberrecht</h2>
          <p>
            Die Website dient der Information über die Tätigkeit und Services
            von Adrian Hufnagl.
          </p>
          <p>
            Alle Inhalte werden mit größter Sorgfalt erstellt, dennoch kann
            keine Haftung für Richtigkeit, Vollständigkeit oder Aktualität
            übernommen werden. Für Inhalte externer Websites, auf die verwiesen
            wird, übernehmen wir keine Verantwortung.
          </p>
          <p>
            Änderungen oder Ergänzungen der bereitgestellten Inhalte bleiben
            vorbehalten.
          </p>
          <p>
            Sämtliche Texte, Bilder, Grafiken und sonstigen Inhalte dieser
            Website unterliegen dem Urheberrecht. Jede Nutzung, Vervielfältigung
            oder Weitergabe zu kommerziellen Zwecken ist ohne ausdrückliche
            Zustimmung nicht gestattet.
          </p>
        </section>
      </div>
    </div>
  );
};

export default ImpressumScreen;
